import { useTranslation } from 'react-i18next';
import { formatPrice } from '@anytag/shared-utils';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useTiktokBudgetAllocationQuery } from '@anytag/graphql';
import { CURRENCY_SYMBOLS } from '@anytag/shared-constants';
import { AdvertiserAdAccountsList } from '@anytag/shared-organisms';
import { useAdvertiserDetailsContext } from './advertiser-details-context';

export const AdvertiserBudgetAllocation = () => {
  const { t } = useTranslation();
  const { advertiser } = useAdvertiserDetailsContext();
  const { data, loading } = useTiktokBudgetAllocationQuery({ variables: { advertiserId: advertiser.id } });

  const tiktokBudgetAllocation = data?.tiktokBudgetAllocation;
  const currencyId = tiktokBudgetAllocation?.currencyId;

  return (
    <div data-card-connect-top>
      <RenderDataWithFallback loading={loading}>
        <div className="box-border rounded-sm bg-white p-6">
          <p className="text-md leading-none font-semibold">{t('Prepaid balance')}</p>
          <p className="mt-4 text-4xl leading-none font-semibold">
            {currencyId ? CURRENCY_SYMBOLS[currencyId] : ''}
            {formatPrice(tiktokBudgetAllocation?.prepaidBalance || 0, null, 0)}
          </p>
        </div>

        <AdvertiserAdAccountsList loading={loading} data={tiktokBudgetAllocation?.adAccounts || []} />
      </RenderDataWithFallback>
    </div>
  );
};
